import { TypedDocumentNode, gql } from '@apollo/client';

import { Skeleton } from '@sorare/core/src/atoms/loader/Skeleton';
import { LineupCount } from '@sorare/core/src/components/lobby/CompetitionList/Ranking';

import { CompetitionDetailsGameplayParticipants_LeaderboardInterface } from './__generated__/index.graphql';

type Props = {
  leaderboard?: CompetitionDetailsGameplayParticipants_LeaderboardInterface | null;
};

export const Participants = ({ leaderboard }: Props) => {
  return (
    <Skeleton loading={!leaderboard}>
      {leaderboard && <LineupCount count={leaderboard.lineupsCount} />}
    </Skeleton>
  );
};

Participants.fragments = {
  LeaderboardInterface: gql`
    fragment CompetitionDetailsGameplayParticipants_LeaderboardInterface on LeaderboardInterface {
      slug
      lineupsCount
    }
  ` as TypedDocumentNode<CompetitionDetailsGameplayParticipants_LeaderboardInterface>,
};
